import { render, staticRenderFns } from "./ModalSubAccount.vue?vue&type=template&id=55c69a8e&"
import script from "./ModalSubAccount.vue?vue&type=script&lang=js&"
export * from "./ModalSubAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports